import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneCall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.414,
		strokeWidth: 1.5,
		d: "M13 1.75c2.9 0 5.25 2.35 5.25 5.25M12 4.75A3.25 3.25 0 0 1 15.25 8M6.015 2.015s2.22 2.265 2.272 2.426a1 1 0 0 1 0 .618c-.074.228-1.271 1.32-1.677 1.859-.405.539-.478 1.34-.283 1.88.048.133.425.936.783 1.484.788 1.206 1.41 1.808 2.608 2.608.656.438 1.63.882 1.791.935a2 2 0 0 0 1.435-.072c.453-.202 1.896-1.23 2.065-1.272.158-.039.324-.039.482 0 .169.042 1.492.924 1.806 1.133a2.14 2.14 0 0 1 .953 1.782 2.854 2.854 0 0 1-2.854 2.854h-2.48a6.814 6.814 0 0 1-3.144-.768 17.033 17.033 0 0 1-7.254-7.254 6.813 6.813 0 0 1-.768-3.144v-1.71A3.625 3.625 0 0 1 5.375 1.75c.24 0 .47.095.64.265Z"
	})]
});
const ForwardRef = forwardRef(SvgPhoneCall);
export { ForwardRef as ReactComponent };
